import React from 'react';

const BookSection: React.FC = () => {
  return (
    <section id="il-libro" className="py-5 bg-light">
      <div className="container">
        <div className="row g-5 align-items-center">
          <div className="col-md-5">
            <div className="card shadow border-0 h-100">
              <div className="card-img-top ratio ratio-3x4 bg-primary bg-gradient text-white p-4">
                <div className="d-flex flex-column justify-content-center align-items-center text-center h-100">
                  <h3 className="fs-4 fw-bold mb-2 text-white">
                    Dove i libri<br />mettono radici
                  </h3>
                  <hr className="w-25 opacity-25 my-3" />
                  <span className="fs-5">Silio</span>
                </div>
              </div>
              <div className="card-body text-center p-4">
                <span className="fs-4 fw-bold text-primary">€9,90</span>
                <a 
                  href="https://bookolica.gumroad.com/l/doveilibrimettonoradici" 
                  className="btn btn-primary d-block mt-3"
                >
                  <i className="bi bi-cart me-2"></i> Acquista ora
                </a>
              </div>
            </div>
          </div>
          
          <div className="col-md-7">
            <span className="badge bg-primary bg-opacity-10 text-primary mb-3 fw-semibold">IL LIBRO</span>
            <h2 className="display-6 fw-bold mb-4">Dove i libri mettono radici</h2>
            
            <div className="mb-4">
              <div className="d-flex mb-2">
                <div className="fw-bold text-muted me-2">Autore:</div>
                <div>Silio</div>
              </div>
              <div className="d-flex mb-2">
                <div className="fw-bold text-muted me-2">Pubblicato:</div>
                <div>Marzo 2025</div>
              </div>
              <div className="d-flex mb-2">
                <div className="fw-bold text-muted me-2">Pagine:</div>
                <div>248</div>
              </div>
            </div>
            
            <p className="lead mb-4">
              Un viaggio profondo nel mondo dell'editoria e della letteratura, dove ogni pagina è una radice che si estende nell'anima del lettore.
            </p>
            
            <div className="mb-4">
              <h5 className="fw-bold mb-3">Sinossi</h5>
              <p>
                In un'epoca dominata dalla velocità e dalla superficialità, "Dove i libri mettono radici" ci invita a riscoprire il valore profondo della lettura e delle storie che trasformano. Attraverso aneddoti personali, riflessioni filosofiche e citazioni letterarie, Silio ci guida in un viaggio tra pagine che hanno cambiato la vita di molti, esplorando come i libri non siano semplici oggetti, ma organismi viventi capaci di mettere radici nel terreno fertile della nostra coscienza.
              </p>
            </div>
            
            <div className="card bg-white shadow-sm mb-4">
              <div className="card-body">
                <h5 className="card-title fw-bold">Incluso nell'acquisto</h5>
                <ul className="list-group list-group-flush">
                  <li className="list-group-item border-0 ps-0">
                    <i className="bi bi-check-circle-fill text-success me-2"></i>
                    Accesso all'e-book in formato PDF e EPUB
                  </li>
                </ul>
              </div>
            </div>
            
            <div className="text-center text-md-start">
              <a 
                href="https://bookolica.gumroad.com/l/doveilibrimettonoradici" 
                className="btn btn-primary btn-lg"
              >
                <i className="bi bi-cart me-2"></i> Acquista per €9,90
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default BookSection; 